export default __webpack_public_path__ + "static/media/down_gray.5a08d1bf.svg";